const styles = {
    svg: {
        width: 'auto',
        height: '40px',
    },
};

const LogoIcon = () => {
    const logoPath = '/logo-mark-white.png';

    return (
            <img
                    src={logoPath}
                    alt="Withe Pocteo Platform Logo"
                    style={styles.svg}
            />
    );
};

export default LogoIcon;